import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Content from './pages/Content';
import AboutUs from './pages/AboutUs';
import News from './pages/News';
import Team from './pages/Team';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import Tracking from './components/Google Analytics/Tracking';
import Footer from './components/Footer';
import HotFix from './components/HotFix/HotFix';
import { RouteHistoryProvider } from './routing/RouteHistoryProvider';

function App() {
  // Inline redirect component
  const RedirectToAmazon = () => {
    useEffect(() => {
      // Fire GA event
      if (window.gtag) {
        window.gtag('event', 'redirect_shop_clicked', {
          page: '/shop',
          destination: 'https://www.amazon.com/game7'
        });
      }

      // Delay ensures GA sends the event
      setTimeout(() => {
        window.location.href = 'https://www.amazon.com/game7';
      }, 150);
    }, []);

    return null;
  };

  const RedirectToRangers = () => {
    useEffect(() => {
      // Fire GA event
      if (window.gtag) {
        window.gtag('event', 'redirect_rangers_clicked', {
          page: '/rangers',
          destination:
            'https://www.amazon.com/stores/page/199999F8-AD47-4F77-963D-AE9A574CBA77'
        });
      }

      // Delay ensures GA sends the event
      setTimeout(() => {
        window.location.href =
          'https://www.amazon.com/stores/page/199999F8-AD47-4F77-963D-AE9A574CBA77?ingress=3&visitId=b9edf114-7e77-4816-9dec-b9e98ef64f77';
      }, 150);
    }, []);

    return null;
  };

  return (
    <Router>
      <RouteHistoryProvider>
        <Tracking />
        <div className="App">
          <HotFix />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/content" element={<Content />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/news" element={<News />} />
              <Route path="/team" element={<Team />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shop/internal" element={<Shop />} />
              <Route path="/shop" element={<RedirectToAmazon />} />
              <Route path="/rangers" element={<RedirectToRangers />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </RouteHistoryProvider>
    </Router>
  );
}

export default App;
